'use strict';

export { WorkletsModule } from './workletsModuleInstance';
//# sourceMappingURL=index.js.map